import { gql } from '@apollo/client';

export const EXPORT_SCHOOL_ATTENDANCE = gql`
  query ExportSchoolAttendance($input: ExportArgs!) {
    exportSchoolAttendance(input: $input) {
      id
      name
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subjects {
        id
        name
        subjectGradeReference
      }
      schoolAttendanceData {
        id
        absentDays
        absenteeismRate
        actualAttendance
        attendanceRate
        circuit {
          id
          name
        }
        district {
          id
          name
        }
        emisNumber
        grade {
          id
          value
        }
        numberEnrolled
        possibleAttendance
        term
        year
        institution {
          id
          emisNumber
          name
        }
      }
    }
  }
`;
